module.exports = __webpack_public_path__ + "img/MGH-Toyosu-5-2440x1172.7c2a8553.jpg";